<template>
  <div
    :class="[
      'filter',
      { 'filter--negative': negative, 'filter--translated': $i18n.locale !== 'en' },
    ]"
  >
    <sui-grid :columns="1" container>
      <sui-grid-row>
        <sui-grid-column style="padding: 0;">
          <ul
            class="filter__list filter__list--desktop"
            :class="[{ 'filter__list--translated': $i18n.locale !== 'en' }]"
            v-if="allFilters.length > 0"
          >
            <li
              :class="[
                'filter__list__item',
                {
                  'filter__list__item--selected':
                    filter.regional_slug === (currentFilter || filterActive),
                },
              ]"
              @click="select(filter.regional_slug, filter.regional_name, filter.regional_id)"
              v-for="filter in allFilters"
              :key="filter.regional_name"
            >
              {{ filter.regional_name }}
            </li>
          </ul>

          <ul
            v-if="allFilters.length > 0"
            :class="[
              'filter__list filter__list--mobile',
              { 'filter__list--opened': showListOptions },
            ]"
          >
            <li class="filter__list__item">
              {{ allFilters[0].regional_name }}
            </li>
            <li class="filter__list__item">
              <div class="filter__list__item__select" @click="showListOptions = !showListOptions">
                {{ currentSelected }}
              </div>

              <transition
                enter-active-class="animated fadeIn"
                leave-active-class="animated fadeOut"
                mode="out-in"
              >
                <div class="filter__list__item__options" v-show="showListOptions">
                  <li
                    :class="['filter__list__item__options--item']"
                    @click="select(filter.regional_slug, filter.regional_name, filter.regional_id)"
                    v-for="filter in filters"
                    v-show="currentSelected !== filter.regional_name"
                    :key="filter.regional_name"
                  >
                    {{ filter.regional_name }}
                  </li>
                </div>
              </transition>
            </li>
          </ul>
        </sui-grid-column>
      </sui-grid-row>
    </sui-grid>
  </div>
</template>

<script>
export default {
  name: "filter-country",
  props: {
    negative: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
    },
  },
  data() {
    return {
      filterActive: "all",
      currentSelected: "All Offices",
      showListOptions: false,
      filters: [],
    };
  },

  computed: {
    allFilters() {
      if (this.filters.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.filters[0].regional_name = this.text || `${this.$t("footer.weare")} DAVID`;
      }
      return this.filters;
    },

    currentFilter() {
      if (this.filters.length > 0) {
        const filter = this.filters.find(
          (item) => item.regional_id === this.$store.state.ui.currentFilter
        );

        if (filter) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.filterActive = filter.regional_slug;
          return filter.regional_slug;
        }

        return this.filterActive;
      }

      return null;
    },
  },

  mounted() {
    this.getFilters();
    this.$hub.$on("fixFilterLanguage", this.translateFilter);
  },

  destroyed() {
    this.$hub.$off("fixFilterLanguage");
  },

  methods: {
    getFilters() {
      this.$offices.get().then((resolve) => {
        this.filters = [
          {
            regional_name: this.text || `${this.$t("footer.weare")} DAVID`,
          },
          {
            regional_name: this.$t("generals.offices"),
            regional_slug: "all",
          },
          ...resolve.data.items,
        ];
        this.translateFilter();
      });
    },

    resetFilters() {
      this.currentSelected = this.$t("generals.offices");
      this.filterActive = "all";
    },

    translateFilter() {
      if (this.filters.length === 0) return;

      this.currentSelected =
        this.filters.find((item) => item.regional_id === this.$store.state.ui.currentFilter)
          ?.regional_name || this.$t("generals.offices");
      this.filters[1].regional_name = this.$t("generals.offices");
    },

    select(filter, title, id) {
      if (!filter || filter === this.filterActive) return;

      this.filterActive = filter;
      this.currentSelected = title;
      this.showListOptions = false;
      this.$store.dispatch("setFilter", null);

      this.$emit("onSelectFilter", { value: filter === "all" ? filter : title, id });
    },
  },
};
</script>

<style lang="scss">
@import "./styles/filter";
</style>
